/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import TimezoneSelect from 'react-timezone-select';

import '../index.scss';

import Footer from 'components/Footer2';
import iconError from '../../../assets/images/icone_advertencia.svg';

import Header from '../../../components/Header';
import NewBotUploadAvatar from './NewBotUploadAvatar';
import { BotsCreators } from '../../../store/actions/bots';
import { getTemplateBotById } from '../../../store/actions/template-bot';
import { setCurrentTemplateBotSelected } from '../../../store/actions/new-bot';
import { ItemsCreators } from '../../../store/actions/items';
import { formatFileToBackend, itemsWithConfig } from './utils';

const labelInputStyle = {
  fontSize: '14px',
  fontWeight: '500',
};
const buttonStyle = { marginLeft: '330px' };
const configItemWarningsStyle = { display: 'none' };

const NewBotCreate = (props) => {
  const { match, newBotTemplateBot, currentTemplateBotSelected, items } = props;
  const [currentFile, setCurrentFile] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [newBotName, setNewBotName] = useState('');
  const [configItems, setConfigItems] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(currentTemplateBotSelected)) {
      const { getAllItems } = props;
      getAllItems({ botId: currentTemplateBotSelected.fromBotId });
    }
  }, [currentTemplateBotSelected]);

  useEffect(() => {
    if (items.length > 0) {
      const configItems = _.uniqBy(
        items.filter((item) =>
          itemsWithConfig.find((element) => element.type === item.type)
        ),
        'type'
      );
      setConfigItems(configItems);
    }
  }, [items]);

  useEffect(() => {
    if (_.isEmpty(currentTemplateBotSelected)) {
      const { getTemplateBotById } = props;
      const { templateId } = match.params;

      if (templateId) {
        getTemplateBotById(templateId);
      }
    }
  }, [currentTemplateBotSelected, match.params]);

  useEffect(() => {
    if (
      !_.isEmpty(newBotTemplateBot) &&
      _.isEmpty(currentTemplateBotSelected)
    ) {
      const { setCurrentTemplateBotSelected } = props;
      setCurrentTemplateBotSelected(newBotTemplateBot);
    }
  }, [currentTemplateBotSelected, newBotTemplateBot]);

  const onChangeBotName = (event) => {
    setNewBotName(event.target.value);
  };

  const onClickContinueButton = (event) => {
    event.preventDefault();
    const { signedUser } = props;
    if (signedUser?.selectedCompany?.claim?.name) {
      const { selectedOrganization: organizationId } = signedUser;
      const companyId = signedUser.selectedCompany._id;
      const { fromBotId } = !_.isEmpty(newBotTemplateBot)
        ? newBotTemplateBot
        : currentTemplateBotSelected;
      const { templateId } = match.params;
      const { newBotRequest } = props;
      const title = newBotName !== '' ? newBotName : 'Novo Bot';
      const data = {
        companyId,
        organizationId,
        title,
        ...(currentFile && {
          file: formatFileToBackend(croppedImage, currentFile),
        }),
        ...(templateId && { templateId }),
        ...(fromBotId && { botId: fromBotId }),
      };
      newBotRequest(data);
    }
  };

  const renderConfigWarningList = () => {
    if (configItems.length < 1) {
      return false;
    }

    return configItems.map((configItem) => {
      const item = itemsWithConfig.find(
        (element) => element.type === configItem.type
      );
      return (
        <div
          key={configItem._id}
          className="new-bot-create-element-warnings-row"
        >
          <img src={iconError} alt=" Warning" />
          <label>{item.name}</label>
        </div>
      );
    });
  };

  return (
    <div className="new-bot-create-main">
      <Header pagetype="page-inicio" />
      <div className="new-bot-create-content">
        <div className="new-bot-create-element">
          <label>Novo Bot</label>
        </div>
        <NewBotUploadAvatar
          croppedImage={croppedImage}
          setCroppedImage={setCroppedImage}
          currentFile={currentFile}
          setCurrentFile={setCurrentFile}
        />
        <div className="new-bot-create-element">
          <label style={labelInputStyle}>Nome do bot:</label>
          <input
            name="botName"
            className="form-control"
            placeholder="Ex.: RH"
            value={newBotName}
            onChange={onChangeBotName}
            maxLength={26}
          />
        </div>
        <div
          className="new-bot-create-element"
          style={configItems.length > 0 ? {} : configItemWarningsStyle}
        >
          <label style={{ ...labelInputStyle, color: '#F15F52' }}>
            Não esqueça de configurar
          </label>
          <div className="new-bot-create-element-warnings">
            {renderConfigWarningList()}
          </div>
        </div>
        <div className="new-bot-create-element" style={buttonStyle}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onClickContinueButton}
          >
            continuar
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    signedUser: state.users.signedUser,
    currentTemplateBotSelected: state.newBot.currentTemplateBotSelected,
    newBotTemplateBot: state.templateBot.newBotTemplateBot,
    items: state.items.allItems,
    bot: state.bots,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...BotsCreators,
      ...ItemsCreators,
      getTemplateBotById,
      setCurrentTemplateBotSelected,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBotCreate);
